/*
 * Example usage:
 * const filterBy = ['copy.name', 'styleGenderAge', 'category', 'colorName', 'productCode'];
 * const updatedList = filterListNested(products, filterBy, inputValue);
 */

const getNestedObject = (object, keyArray) =>
  keyArray.reduce((obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), object);

const handleNestedKey = value => value.split('.') || [value];

const normalizeValue = value => (value ? value.toString().toLowerCase().replace(/\W/g, '') : '');

export const filterObject = (object, objectKeys, inputVal) => {
  const normalizeInput = normalizeValue(inputVal);
  return objectKeys.some(key => {
    const updatedKey = handleNestedKey(key);
    return normalizeValue(getNestedObject(object, updatedKey)).search(normalizeInput) !== -1;
  });
};

export function filterListNested(list, objectKeys, inputVal) {
  return list ? list.filter(object => filterObject(object, objectKeys, inputVal)) : [];
}
